/* global axios */
import ApiClient from '../ApiClient';

// Flight shortlists sent into a conversation, and the two write actions that follow the
// customer's choice. `hold` and `confirm` carry an idempotency key because the write gate
// refuses a write without one - a double-click must never become two held seats.
class TravelQuotes extends ApiClient {
  constructor() {
    super('travel/quotes', { accountScoped: true });
  }

  create(quote) {
    return axios.post(this.url, { quote });
  }

  hold(id, idempotencyKey) {
    return axios.post(`${this.url}/${id}/hold`, {
      idempotency_key: idempotencyKey,
    });
  }

  confirm(id, idempotencyKey) {
    return axios.post(`${this.url}/${id}/confirm`, {
      idempotency_key: idempotencyKey,
    });
  }
}

export default new TravelQuotes();
